import React from 'react';
import { Eye } from 'lucide-react';
import LandingPreviewBlock from '@/components/LandingPreviewBlock';
import WhistleLandingBlock from '@/components/WhistleLandingBlock';

export const BrandingPreview = ({ brandingData, tenant }) => {
  if (brandingData.layout_style === 'whistle') {
    return (
      <div className="rounded-lg border border-slate-200 overflow-hidden" data-testid="whistle-live-preview">
        <div className="bg-slate-900 text-white text-xs font-medium px-4 py-2 flex items-center gap-2">
          <Eye className="w-3.5 h-3.5" /> Pré-visualização em Direto — página pública (Whistle)
        </div>
        <div className="max-h-[600px] overflow-y-auto">
          <WhistleLandingBlock
            tenantSlug={tenant?.slug}
            tenantName={tenant?.name || 'A Sua Empresa'}
            heroImageUrl={brandingData.hero_image_url}
            primaryColor={brandingData.primary_color}
            institutionalText={brandingData.institutional_text}
            supportEmail={brandingData.support_email}
            supportSignature={brandingData.support_signature}
            interactive={false}
            sticky={false}
          />
        </div>
      </div>
    );
  }

  if (brandingData.layout_style === 'whistlelink_style') {
    return (
      <div className="rounded-lg border border-slate-200 overflow-hidden" data-testid="whistlelink-live-preview">
        <div className="bg-slate-900 text-white text-xs font-medium px-4 py-2 flex items-center gap-2">
          <Eye className="w-3.5 h-3.5" /> Pré-visualização em Direto — página pública
        </div>
        <div className="max-h-[600px] overflow-y-auto">
          <LandingPreviewBlock
            tenantName={tenant?.name || 'A Sua Empresa'}
            heroTitle={brandingData.hero_title}
            heroSubtitle={brandingData.hero_subtitle}
            heroImageUrl={brandingData.hero_image_url}
            primaryColor={brandingData.primary_color}
            logoUrl={brandingData.company_logo_url}
            institutionalText={brandingData.institutional_text}
            supportEmail={brandingData.support_email}
            supportSignature={brandingData.support_signature}
            interactive={false}
            sticky={false}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-lg border border-slate-200 overflow-hidden">
      <div
        className="p-6 text-white"
        style={{
          backgroundColor: brandingData.primary_color,
          backgroundImage: brandingData.hero_image_url
            ? `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${process.env.REACT_APP_BACKEND_URL}${brandingData.hero_image_url})`
            : 'none',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <h3 className="text-xl font-bold">{brandingData.hero_title || 'Canal de Denúncias Interno'}</h3>
        <p className="text-sm opacity-90 mt-1">{brandingData.hero_subtitle || 'Submeta a sua denúncia de forma segura'}</p>
      </div>
      <div className="bg-slate-50 p-3 text-center text-xs text-slate-500">
        Pré-visualização do banner
      </div>
    </div>
  );
};

